// module.exports.pipe =
//   (...functions) =>
//   (input) =>
//     functions.reduce((chain, func) => chain.then(func), Promise.resolve(input));

//this is a regular pipe, not async, does not return promises
export const pipe =
  (...functions) =>
  (args) =>
    functions.reduce((arg, fn) => fn(arg), args);

export const trace =
  (message, indent = null) =>
  ({ events, ...props }) => {
    console.log(JSON.stringify({ message, data: { ...props } }, null, indent));
    return { ...props, events };
  };
